import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import ReadOnlyProviderBanner from "./ReadOnlyProviderBanner";

export default function AppLayout() {
  return (
    <div className="flex min-h-screen bg-[#F9F8F6]" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 overflow-auto flex flex-col">
        {/* FP3-029B3 — Calm banner rendered when an admin enters
            read-only provider workspace mode via ?as_provider=. The
            banner self-checks role + URL param; no-op for regular
            provider sessions. */}
        <ReadOnlyProviderBanner />
        {/* FP3-053 — The Super Admin "Viewing {Org}" banner that used
            to sit here was redundant once the sidebar context
            selector was introduced. The selector itself + the
            in-page subtitle ("Viewing: …") are the single source
            of truth now, and removing the banner gives operational
            pages back ~50px of vertical real estate. The "Back to
            Platform Dashboard" affordance lives inside the sidebar
            selector's dropdown footer. */}
        <div className="flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
